import { inject, Injectable } from '@angular/core';
import { StateContext } from '@ngxs/store';
import { TableStateModel } from '../table.state.model';
import { Pagination } from '@core/models/pagination.model';
import { CommonService } from '@core/services/common.service';
import { TableActions } from '../table.actions';

@Injectable({
  providedIn: 'root',
})
export class BanksHandler {
  constructor() {}
  commonService = inject(CommonService);

  handleBanksLoad(
    ctx: StateContext<TableStateModel>,
    params: Pagination
  ) {
    const state = ctx.getState();
    const search = state.banks?.filters?.['search'] as string;

    this.commonService.getBankList(params, search).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'banks',
            data: response.data,
            totalCount: response.data_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'banks',
            error: error.message,
          })
        );
      },
    });
  }
}
